module.exports = __webpack_public_path__ + "static/img/cont59 (2).a532f99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (2).jpg
// module id = w9Az
// module chunks = 0